import styled from 'styled-components'
import AddCircleIcon from '../asset/AddCircleIcon'

type AddBtnSize = 'sm' | 'md' | 'lg'

const sizeStyles: Record<
  AddBtnSize,
  { fontSize: string; gap: string; iconWidth: number; iconHeight: number }
> = {
  sm: {
    fontSize: '0.75em',
    gap: '4px',
    iconWidth: 12,
    iconHeight: 13,
  },
  md: {
    fontSize: '0.875em',
    gap: '6px',
    iconWidth: 14,
    iconHeight: 15,
  },
  lg: {
    fontSize: '1em',
    gap: '8px',
    iconWidth: 16,
    iconHeight: 17,
  },
}

const getSizeStyle = (size: AddBtnSize) => sizeStyles[size]

const StyledAddBtn = styled.div<{ $size: AddBtnSize }>`
  display: flex;
  align-items: center;
  font-size: ${({ $size }) => getSizeStyle($size).fontSize};
  gap: ${({ $size }) => getSizeStyle($size).gap};
  margin-top: 0.25em;
  cursor: pointer;

  svg {
    width: ${({ $size }) => getSizeStyle($size).iconWidth}px;
    height: ${({ $size }) => getSizeStyle($size).iconHeight}px;
  }
`

type AddTableButtonProps = {
  onAdd: () => void
  size?: AddBtnSize
}

export const AddBtn: React.FC<AddTableButtonProps> = ({
  onAdd,
  size = 'sm',
}) => {
  return (
    <StyledAddBtn onClick={onAdd} $size={size}>
      <AddCircleIcon />
      <span>추가하기</span>
    </StyledAddBtn>
  )
}

/* 
아래와 같은 함수를 만들어서 사용하면 됩니다.

type Row = {
  id: number
  customerName: string
  plan: string
  annualGeneration: number
  generationCost: number
}

  const [rows, setRows] = useState<Row[]>([])

const addRow = () => {
    const newRow: Row = {
        id: new Date().getTime(),
        customerName: '',
        plan: '',
        annualGeneration: 0,
        generationCost: 0,
      }
      setRows([...rows, newRow])
    }
*/
